/** @format */
import { memo } from "react";
import styled from "styled-components";

import ExpenseDate from "./ExpenseDate";

const ExpenseItem = ({ title, id, amount, date }) => {
	return (
		<li>
			<ExpenseItemWrapper>
				<ExpenseDate date={date} />
				<div className='expense-item__description'>
					<h2>{title}</h2>
					<div className='expense-item__price'>${amount}</div>
				</div>
			</ExpenseItemWrapper>
		</li>
	);
};

export default memo(ExpenseItem);

const ExpenseItemWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
	padding: 0.5rem;
	margin: 1rem 0;
	border-radius: 12px;
	background-color: #4b4b4b;

	.expense-item__description {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		align-items: flex-end;
		flex-flow: column-reverse;
		justify-content: flex-start;
		flex: 1;
	}

	h2 {
		color: #3a3a3a;
		font-size: 1rem;
		flex: 1;
		margin: 0 1rem;
		color: #fff;
	}

	.expense-item__price {
		font-size: 1rem;
		font-weight: bold;
		color: white;
		background-color: #40005d;
		border: 1px solid white;
		padding: 0.5rem;
		border-radius: 12px;
	}

	@media (min-width: 580px) {
		.expense-item__description {
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			flex: 1;
		}

		.expense-item__description h2 {
			font-size: 1.25rem;
		}

		.expense-item__price {
			font-size: 1.25rem;
			padding: 0.5rem 1.5rem;
		}
	}
`;
